import {
  ICreateProductTemplateRequest,
  IProductTemplate,
  IProductTemplateVariant,
  IProductTemplateVariantRequest,
} from '../interfaces/Order';
import {
  PaginationParamsRequest,
  PaginationParamsResponse,
} from '../interfaces/PaginationParamsResponse';
import Client from './client';

class ProductTemplateApi {
  private static classInstance?: ProductTemplateApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new ProductTemplateApi();
    }
    return this.classInstance;
  }

  async getProductTemplates(
    params: PaginationParamsRequest = {}
  ): Promise<PaginationParamsResponse<IProductTemplate>> {
    const { page = 1, perPage = 100 } = params;

    return await Client.get(`/product-template`, {
      params: {
        page,
        perPage,
      },
    });
  }

  async getProductTemplateById(id: string): Promise<IProductTemplate> {
    return await Client.get(`/product-template/${id}`);
  }

  async createProductTemplate(
    data: ICreateProductTemplateRequest
  ): Promise<IProductTemplate> {
    return await Client.post(`/product-template`, data);
  }

  async updateProductTemplate(
    id: string,
    data: Partial<ICreateProductTemplateRequest>
  ): Promise<IProductTemplate> {
    return await Client.patch(`/product-template/${id}`, data);
  }

  async updateProductTemplateVariant(
    id: string,
    data: Partial<IProductTemplateVariantRequest>
  ): Promise<IProductTemplateVariant> {
    return await Client.patch(`/product-template/variant/${id}`, data);
  }

  async deleteProductTemplate(id: string): Promise<void> {
    return await Client.delete(`/product-template/${id}`);
  }

  async uploadProductTemplateImage(data: FormData): Promise<string> {
    return await Client.post(`/product-template/image`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export const productTemplateApi = new ProductTemplateApi();
